
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { ExternalLink } from "lucide-react";
import { useState } from "react";

interface BlogPostProps {
  id: string;
  title: string;
  imageSrc: string;
  imageAlt: string;
  externalLink?: string;
  content: React.ReactNode;
  isExpanded: boolean;
  onToggle: (postId: string) => void;
}

export const BlogPost = ({
  id,
  title,
  imageSrc,
  imageAlt,
  externalLink,
  content,
  isExpanded,
  onToggle
}: BlogPostProps) => {
  return (
    <>
      <div id={id} className="flex flex-col">
        <Card className="flex-grow shadow-lg">
          <div 
            className="relative cursor-pointer"
            onClick={() => onToggle(id)}
          >
            <AspectRatio ratio={16/9}>
              <img 
                src={imageSrc}
                alt={imageAlt}
                className="w-full h-full object-cover transition-transform hover:scale-[1.02]"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black/50 p-4 flex justify-between items-center">
                <h2 className="text-white font-bold text-lg whitespace-nowrap overflow-hidden text-ellipsis">{title}</h2>
                {externalLink && (
                  <a 
                    href={externalLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-white flex items-center bg-blue-500 hover:bg-blue-600 rounded-full p-2 ml-2"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <ExternalLink className="h-4 w-4" />
                  </a>
                )}
              </div>
            </AspectRatio>
          </div>
        </Card>
      </div>
      
      {isExpanded && (
        <div className="col-span-full mt-4 mb-8 animate-fade-in">
          <Card className="shadow-lg border-2 border-primary/50 ring-4 ring-primary/20">
            <CardContent className="bg-white p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-3">{title}</h3>
              {content}
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
};
